import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return data.map(item => {
      let text = `${item.name} - ${item.organization.name} (${item.organization.level})`
      if (item.app) {
        text = `${text} - App: ${item.app.name}`
      }
      return {
        id: item.id,
        text,
        ...item,
      }
    })
  }, [data])
}
